<template>
  <div
    v-bind:style="{
      backgroundImage:
        'url(https://cdn.shopify.com/s/files/1/0528/5969/9371/articles/synthj_4096x.jpg)',
    }"
    class="login-bg"
  >
    <v-main class="pt-4 mt-4">
      <v-container fluid fill-height grid-list-md>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12 signup-card">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div>
                      <div class="headline text-center">
                        <svg
                          width="171"
                          height="22"
                          viewBox="0 0 171 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M39.9167 14.2C39.9167 10.84 37.2767 9.4 33.9167 8.92C30.5567 8.44 29.5967 7.96 29.5967 6.52C29.5967 5.56 30.3167 4.84 32.4767 4.84C35.1167 4.84 35.8367 5.56 35.8367 7L36.0767 7.24H38.9567L39.1967 7C39.1967 4.12 37.2767 1.96 32.7167 1.96C28.1567 1.96 26.2367 4.12 26.2367 6.52C26.2367 9.88 28.8767 11.08 32.2367 11.56C35.5967 12.04 36.5567 12.52 36.5567 14.2C36.5567 15.64 35.3567 16.36 33.1967 16.36C30.3167 16.36 29.3567 15.4 29.3567 13.72L29.1167 13.48H26.2367L25.9967 13.72C25.9967 16.84 28.1567 19.24 32.9567 19.24C37.9967 19.24 39.9167 16.84 39.9167 14.2ZM53.6005 10.6C53.6005 13.96 51.9205 16.36 48.8005 16.36C45.6805 16.36 44.0005 13.96 44.0005 10.6C44.0005 7.24 45.6805 4.84 48.8005 4.84C51.9205 4.84 53.6005 7.24 53.6005 10.6ZM56.9605 10.6C56.9605 5.56 53.8405 1.96 48.8005 1.96C43.7605 1.96 40.6405 5.56 40.6405 10.6C40.6405 15.64 43.7605 19.24 48.8005 19.24C53.8405 19.24 56.9605 15.64 56.9605 10.6ZM72.0748 2.44L71.8348 2.2H68.9548L68.7148 2.44V12.52C68.7148 14.92 67.7548 16.36 65.3548 16.36C62.9548 16.36 61.9948 14.92 61.9948 12.52V2.44L61.7548 2.2H58.8748L58.6348 2.44V12.52C58.6348 16.84 61.0348 19.24 65.3548 19.24C69.6748 19.24 72.0748 16.84 72.0748 12.52V2.44ZM74.7083 2.44V18.76L74.9483 19H77.8283L78.0683 18.76V7.72H78.3083L84.7883 18.76L85.2683 19H88.6283L88.8683 18.76V2.44L88.6283 2.2H85.7483L85.5083 2.44V13.48H85.2683L78.7883 2.44L78.3083 2.2H74.9483L74.7083 2.44ZM105.188 10.6C105.188 5.32 103.028 2.2 97.0283 2.2H91.7483L91.5083 2.44V18.76L91.7483 19H97.0283C103.028 19 105.188 15.88 105.188 10.6ZM101.828 10.6C101.828 14.44 100.628 16.12 97.2683 16.12H95.1083L94.8683 15.88V5.32L95.1083 5.08H97.2683C100.628 5.08 101.828 6.76 101.828 10.6ZM120.799 7.24C120.799 3.88 118.399 2.2 115.039 2.2H107.119L106.879 2.44V18.76L107.119 19H109.999L110.239 18.76V12.52L110.479 12.28H115.039C118.399 12.28 120.799 10.6 120.799 7.24ZM117.439 7.24C117.439 8.92 116.479 9.4 115.039 9.4H110.479L110.239 9.16V5.32L110.479 5.08H115.039C116.479 5.08 117.439 5.56 117.439 7.24ZM133.996 18.76V16.36L128.476 2.44L128.236 2.2H125.116L124.876 2.44L119.356 16.36V18.76L119.596 19H121.756L121.996 18.76L123.196 15.64L123.676 15.4H129.676L130.156 15.64L131.356 18.76L131.596 19H133.756L133.996 18.76ZM128.956 12.28L128.716 12.52H124.636L124.396 12.28L126.556 6.52H126.796L128.956 12.28ZM138.565 18.76V2.44L138.325 2.2H135.445L135.205 2.44V18.76L135.445 19H138.325L138.565 18.76ZM141.2 2.44V18.76L141.44 19H144.32L144.56 18.76V7.72H144.8L151.28 18.76L151.76 19H155.12L155.36 18.76V2.44L155.12 2.2H152.24L152 2.44V13.48H151.76L145.28 2.44L144.8 2.2H141.44L141.2 2.44ZM170.48 4.84V2.44L170.24 2.2H156.8L156.56 2.44V4.84L156.8 5.08H161.6L161.84 5.32V18.76L162.08 19H164.96L165.2 18.76V5.32L165.44 5.08H170.24L170.48 4.84Z"
                            fill="#1B1B1B"
                          ></path>
                          <path
                            d="M0 0.0673759V21.5333H4.21436C4.21436 21.5333 4.28174 17.5164 9.54851 15.2775C14.8153 13.0386 17.7798 11.3266 17.7798 6.58599C17.7798 1.84542 13.8289 0.658599 13.8289 0.658599C13.8289 0.658599 12.3581 0 7.77046 0C1.97546 0 0 0.0673759 0 0.0673759Z"
                            fill="#1B1B1B"
                          ></path>
                        </svg>
                      </div>
                      <p class="text-center font-weight-regular pt-0 mt-0">
                        DEVELOPER PORTAL
                      </p>
                    </div>

                    <br />
                    <v-form>
                      <v-text-field
                        prepend-icon="person"
                        name="email"
                        label="Email"
                        type="email"
                        v-model="email"
                      ></v-text-field>
                      <v-text-field
                        prepend-icon="lock"
                        name="password"
                        label="Password"
                        id="password"
                        type="password"
                        v-model="password"
                      ></v-text-field>
                      <p class="text-xs-right">
                        <a @click="forgotPassword">Forgot your password?</a>
                      </p>
                      <v-btn @click="login" block dark color="primary" large
                        >Sign In</v-btn
                      >
                      <br />
                      <!-- <p class="text-xs-center">
                        Not yet registered?
                        <a href="/signup" :disabled="true">Sign Up</a>.
                      </p> -->
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import fb from "@/main";
import image from "@/assets/img/bg.jpg";
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      image,
    };
  },
  methods: {
    login: async function (e) {
      e.preventDefault();
      try {
        await fb.auth.signInWithEmailAndPassword(this.email, this.password);
        this.$router.push("/");
      } catch (e) {
        alert(e.message);
        console.log(e);
      }
    },
    forgotPassword: function () {
      const email = prompt("Enter your email to request a password reset.");
      if (email) {
        fb.auth
          .sendPasswordResetEmail(email)
          .then(function () {
            alert(
              "Email Sent with password reset link. Check your email inbox."
            );
          })
          .catch(function () {
            console.log("error sending password reset email.");
          });
      }
    },
  },
};
</script>

<style scoped>
.signup-card {
  padding: 15px;
}
.login-bg {
  background-size: cover;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
